import { FeedbackDetails } from '@/modals/feedback/FeedBackDetails';
import { Component, OnInit } from '@angular/core';
import { AppService } from '@services/app.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-feedback',
  templateUrl: './feedback.component.html',
  styleUrls: ['./feedback.component.scss']
})
export class FeedbackComponent implements OnInit {

feedbacks: FeedbackDetails[] = [];

  constructor(private appService: AppService,
     private toaster: ToastrService,
    private spinner: NgxSpinnerService
  ) { }

  ngOnInit(): void {
    this.loadFeedbacks();
  }

  loadFeedbacks(): void {
    this.spinner.show();

    this.appService.getAllFeedbacks().subscribe({
      next: (data) => {
        this.feedbacks = data.sort(
          (a: any, b: any) => b.feedbackDetailsSeq - a.feedbackDetailsSeq
        );
      },
      error: (err) => {
        console.error('Error loading Feedbacks:', err);
      },
      complete: () => {
        setTimeout(() => this.spinner.hide(), 2000);
      },
    });
  }

  updateContentShow(feedback: any) {

    const payload = {
      feebackDetailsSeq: feedback.feedbackDetailsSeq, // use correct property from object
      contentShow: feedback.contentShow
    };

    this.spinner.show();

    this.appService.updateFeedbackContentShow(payload).subscribe({
      next: () => {
        this.toaster.success('Content show updated');
      },
      error: (err) => {
        console.error('Update content show failed', err);
        this.toaster.error('Update failed');
      },
      complete:() => {
        setTimeout(() => this.spinner.hide(),2000)
      },
    });
  }

}
